/**
 * Shared messaging surface access — keep navbar + Profile Messages in sync.
 *
 * Show Messages when the Messaging module is on AND the user has any messaging
 * surface: group messaging permission and/or shift/on-call capabilities.
 */

export function hasMessagingSurfaceAccess({
  hasModule,
  hasPermission,
  capabilities = null,
}) {
  if (typeof hasModule === 'function' && !hasModule('Messaging')) {
    return false;
  }

  if (typeof hasPermission === 'function' && hasPermission('messaging.group.view')) {
    return true;
  }

  if (capabilities && typeof capabilities === 'object') {
    return Boolean(
      capabilities.groups_enabled ||
        capabilities.show_oncall_tab ||
        capabilities.can_send_shift_messages ||
        capabilities.can_receive_oncall_requests ||
        (capabilities.shift_thread_count || 0) > 0
    );
  }

  // Sync fallback while capabilities load / if fetch fails
  if (typeof hasPermission === 'function') {
    return (
      hasPermission('scheduling.oncall.respond') ||
      hasPermission('scheduling.oncall.view_own') ||
      hasPermission('scheduling.shift.view')
    );
  }

  return false;
}

export const MESSAGING_ROUTE_PERMISSIONS = [
  'messaging.group.view',
  'scheduling.oncall.respond',
  'scheduling.oncall.view_own',
  'scheduling.shift.view',
];
